<template>
    <div class="grid grid-cols-2 gap-4 mb-4">
        <div class="flex col-span-2 sm:col-span-1 transition duration-500 ease-in-out dark:text-white overflow-scroll justify-center sm:justify-start">
            <!-- <h4 class="font-semibold mr-2">Surface:</h4> {{ race.surface }} -->
            <h4 class="font-semibold mr-2">Class:</h4> {{ race.class }}
            <!-- <h4 class="font-semibold mr-2 ml-4">Yards:</h4> {{ race.distance }}
            <h4 class="font-semibold mr-2 ml-4">Miles:</h4> {{ yardsToMiles(race.distance) }} -->
            <!-- <h4 class="font-semibold mr-2 ml-4">Furlongs:</h4> {{ race.furlongs }} -->
            <h4 class="font-semibold mr-2 ml-4">Distance:</h4> {{ yardsToMilesAndFurlongs(race.distance) }}
            <!-- <h4 v-if="race.fences" class="font-semibold mr-2 ml-4">Fences:</h4> {{ race.fences }} -->
        </div>
        <div class="flex col-span-2 sm:col-span-1 transition duration-500 ease-in-out dark:text-white justify-end" v-if="race.results.length">
            <h4 class="font-semibold mr-2">Total Points:</h4> {{ sumBy(race.results, 'points').toFixed(2) }}
        </div>
        <div v-else class="hidden sm:flex col-span-2 sm:col-span-1 transition duration-500 ease-in-out dark:text-white justify-end">
            <h4 class="font-semibold mr-2">Forcasted Odds</h4>
        </div>
    </div>
    <div class="grid-cols-1 hidden md:grid" v-if="runners && !race.results.length">
        <div v-for="(runner, key) in runners" :key="key" class="relative border-t border-gray-300 bg-white flex items-center hover:border-gray-300 cursor-pointer flex-wrap dark:bg-gray-900 dark:border-gray-600 dark:hover:border-gray-700 transition duration-500 ease-in-out" @click="selectRunner(runner)" v-if="moment(race.starts_at).subtract(2, 'minutes').isAfter(moment())">

            <div class="px-6 py-5 w-full flex items-center">
                <div class="hidden sm:block sm:shrink-0 mr-2">
                    <p class="text-gray-900 text-sm font-semibold flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                        {{ runner.start_number }}
                    </p>
                    <p v-if="runner.draw" class="text-gray-900 text-sm flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                        ({{ runner.draw }})
                    </p>
                </div>
                <div class="hidden sm:block sm:shrink-0 dark:rounded-full dark:bg-white dark:p-2 dark:w-10 dark:h-10 dark:items-center dark:justify-center mr-4">
                    <img class="w-10" :src="runner.silk_image_path" alt="" />
                </div>
                <div class="flex w-full sm:min-w-0 sm:flex-1">
                    <p class="text-gray-900 text-sm sm:text-lg font-bold dark:text-white break-words transition duration-500 ease-in-out" v-if="runner.horse">
                        {{ runner.horse.name }}<span v-if="runner.horse.form"> - <strong>{{ runner.horse.form }}</strong></span>
                    </p>
                    <p class="ml-4 hidden sm:block text-sm sm:text-lg text-gray-500 pr-4 truncate inline-block dark:text-white transition duration-500 ease-in-out" v-if="runner.horse && runner.horse.trainer">
                        <strong>Trainer</strong>: {{ runner.horse.trainer.name }}
                    </p>
                    <p class="ml-4 hidden sm:block text-sm sm:text-lg text-gray-500 truncate inline-block dark:text-white transition duration-500 ease-in-out" v-if="runner.jockey">
                        <strong>Jockey</strong>: {{ runner.jockey.name }}
                    </p>
                </div>
                <div class="shrink-0">
                    <p class="text-sm font-semibold text-gray-900 flex justify-left items-center dark:text-white transition duration-500 ease-in-out">
                        {{ runner.forecast_odds_description }}
                    </p>

                    <button v-if="runnerDetailsId === runner.id" @click.stop.prevent="toggleRunnerDetails(runner)" class="inline-flex items-center pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-black dark:text-white transition duration-500 ease-in-out">
                        Show Less&nbsp;
                        <chevron-up-icon class="ml-3 -mr-1 h-5 w-5" aria-hidden="true" />
                    </button>

                    <button v-else @click.stop.prevent="toggleRunnerDetails(runner)" class="inline-flex items-center pr-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-black dark:text-white transition duration-500 ease-in-out">
                        Show More
                        <chevron-down-icon class="ml-3 -mr-1 h-5 w-5" aria-hidden="true" />
                    </button>
                </div>

                <div class="shrink-0">
                    <div v-if="runnerExistsInSelected(runner)" class="h-10 w-10 flex items-center justify-center rounded-full border-2 border-green-400 dark:border-racing-stars-yellow">
                        <check-icon class="text-green-400 dark:text-racing-stars-yellow w-7"/>
                    </div>

                    <div v-else class="h-10 w-10 flex items-center justify-center rounded-full border-2 border-gray-900 text-gray-900 text-xs dark:text-racing-stars-yellow dark:border-racing-stars-yellow transition duration-500 ease-in-out">
                        Pick
                    </div>
                </div>
            </div>

            <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0" enter-to-class="opacity-100" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <div class="w-full p-6 dark:bg-gray-700 m-auto" v-if="runnerDetailsId === runner.id && runner.horse">
                    <div class="flex text-white transition duration-500 ease-in-out overflow-scroll">
                        <h4 class="font-semibold mr-2 dark:text-white transition duration-500 ease-in-out">Form:</h4> {{ (runner.horse && runner.horse.form !== '') ? runner.horse.form : 'None' }}
                        <h4 class="font-semibold mr-2 ml-4 dark:text-white transition duration-500 ease-in-out">Weight:</h4> {{ runner.weight }}
                        <h4 class="font-semibold mr-2 ml-4 dark:text-white transition duration-500 ease-in-out">Rating:</h4> {{ (runner.horse && runner.horse.rating) ? runner.horse.rating : 'None' }}
                        <h4 class="font-semibold mr-2 ml-4 dark:text-white transition duration-500 ease-in-out">Age:</h4> {{ runner.horse.age }}
                        <h4 class="font-semibold mr-2 ml-4 dark:text-white transition duration-500 ease-in-out">Gate:</h4> {{ (runner.draw) ? runner.draw : 'N/A' }}
                    </div>
                    <div class="flex dark:text-white transition duration-500 ease-in-out mt-4 dark:bg-gray-500 rounded p-6">
                        <p class="text-gray-900 flex justify-center items-center dark:text-white transition duration-500 ease-in-out">{{ runner.horse.spotlight }}</p>
                    </div>
                </div>
            </transition>
        </div>
        <div v-else>
            <alert type="info" class="mb-4">
                <template #title>
                    Waiting for Race Results!
                </template>
                <template #message>
                    There currently no results for this race. Please check back later.
                </template>
            </alert>
        </div>

        <div class="grid grid-cols-1 mt-4" v-if="raceHasRunners(reserves, race) && !race.results.length && moment(race.starts_at).subtract(2, 'minutes').isAfter(moment())">
            <h2 class="text-1xl dark:text-white mb-4">Irish Reserves</h2>
            <template v-for="(runner, key) in reserves">
                <div class="relative border-t border-gray-300 bg-white flex items-center hover:border-gray-300 cursor-pointer flex-wrap dark:bg-gray-900 dark:border-gray-600 dark:hover:border-gray-700 transition duration-500 ease-in-out" @click="selectRunner(runner)" v-if="moment(race.starts_at).subtract(2, 'minutes').isAfter(moment()) && belongsToRace(race, runner)" :key="key">
                    <div class="px-6 py-5 w-full flex items-center">
                        <div class="shrink-0 mr-2">
                            <p class="text-gray-900 text-sm font-semibold flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                                {{ runner.start_number }}
                            </p>
                            <p v-if="runner.draw" class="text-gray-900 text-sm flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                                ({{ runner.draw }})
                            </p>
                        </div>
                        <div class="shrink-0 dark:rounded-full dark:bg-white dark:p-2 dark:w-10 dark:h-10 dark:flex dark:items-center dark:justify-center mr-4">
                            <img class="w-10" :src="runner.silk_image_path" alt="" />
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-gray-900 text-lg font-bold dark:text-white transition duration-500 ease-in-out">
                                {{ runner.horse.name }}<span v-if="runner.horse.form"> - <strong>{{ runner.horse.form }}</strong></span>
                            </p>
                            <p class="text-sm text-gray-500 truncate inline-block pr-4 dark:text-white transition duration-500 ease-in-out" v-if="runner.horse && runner.horse.trainer">
                                <strong>Trainer</strong>: {{ runner.horse.trainer.name }}
                            </p>
                        </div>
                        <div class="shrink-0">
                            <p class="text-sm font-semibold text-gray-900 flex justify-left items-center dark:text-white transition duration-500 ease-in-out">
                                {{ runner.forecast_odds_description }}
                            </p>
                        </div>

                        <div class="shrink-0 ml-2">
                            <div v-if="runnerExistsInSelected(runner)" class="h-10 w-10 flex items-center justify-center rounded-full border-2 border-green-400 dark:border-racing-stars-yellow">
                                <check-icon class="text-green-400 dark:text-racing-stars-yellow w-7"/>
                            </div>

                            <div v-else class="h-10 w-10 flex items-center justify-center rounded-full border-2 border-gray-900 text-gray-900 text-xs dark:text-racing-stars-yellow dark:border-racing-stars-yellow transition duration-500 ease-in-out">
                                Pick
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div class="grid grid-cols-1 mt-4" v-if="raceHasRunners(nonRunners, race) && !race.results.length && moment(race.starts_at).subtract(2, 'minutes').isAfter(moment())">
            <h2 class="text-1xl dark:text-white mb-4">Non-Runners</h2>
            <template v-for="(runner, key) in nonRunners">
                <div :key="key" class="relative border-t border-gray-300 bg-white flex items-center hover:border-gray-300 cursor-pointer flex-wrap dark:bg-gray-900 dark:border-gray-600 dark:hover:border-gray-700 transition duration-500 ease-in-out" v-if="moment(race.starts_at).subtract(2, 'minutes').isAfter(moment()) && belongsToRace(race, runner)">

                    <div class="px-6 py-5 w-full flex items-center">
                        <div class="shrink-0 mr-2">
                            <p class="text-gray-900 text-sm font-semibold flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                                {{ runner.start_number }}
                            </p>
                            <p v-if="runner.draw" class="text-gray-900 text-sm flex justify-center items-center dark:text-white transition duration-500 ease-in-out">
                                ({{ runner.draw }})
                            </p>
                        </div>
                        <div class="shrink-0 dark:rounded-full dark:bg-white dark:p-2 dark:w-10 dark:h-10 dark:flex dark:items-center dark:justify-center mr-4">
                            <img class="w-10" :src="runner.silk_image_path" alt="" />
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-gray-900 text-lg font-bold dark:text-white transition duration-500 ease-in-out">
                                {{ runner.horse.name }}<span v-if="runner.horse.form"> - <strong>{{ runner.horse.form }}</strong></span>
                            </p>
                            <p class="text-sm text-gray-500 truncate inline-block pr-4 dark:text-white transition duration-500 ease-in-out" v-if="runner.horse && runner.horse.trainer">
                                <strong>Trainer</strong>: {{ runner.horse.trainer.name }}
                            </p>
                        </div>
                        <div class="shrink-0">
                            <p class="text-sm font-semibold text-gray-900 flex justify-left items-center dark:text-white transition duration-500 ease-in-out">
                                {{ runner.forecast_odds_description }}
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>

    <!-- Mobile -->
    <div class="md:hidden grid grid-cols-1" v-if="runners && !race.results.length">
        <div v-for="(runner, key) in runners" :key="key" class="relative border-t border-gray-300 bg-white flex items-center hover:border-gray-300 flex-wrap dark:bg-gray-900 dark:border-gray-600 dark:hover:border-gray-700 transition duration-500 ease-in-out grid grid-cols-5 p-4 pb-0" v-if="moment(race.starts_at).subtract(2, 'minutes').isAfter(moment())" @click="selectRunner(runner)">
            <div v-if="runnerExistsInSelected(runner)" class="left-0 top-0 right-0 absolute h-1 bg-racing-stars-yellow">&nbsp;</div>
            <div class="dark:text-white col-span-1 text-center">
                {{ runner.start_number }}<br />
                <span>({{ runner.draw }})</span>
            </div>
            <div class="shrink-0 dark:rounded-full dark:bg-white dark:p-2 dark:w-10 dark:h-10 dark:flex dark:items-center dark:justify-center">
                <img class="w-10" :src="runner.silk_image_path" alt="" />
            </div>
            <div class="dark:text-white col-span-2 truncate">
                {{ runner.horse.name }}
                <div class="grid grid-cols-1">
                    <div class="col-span-1 text-xs" v-if="runner.jockey">J: {{ runner.jockey.name }}</div>
                    <div class="col-span-1 text-xs" v-if="runner.horse.trainer">T: {{ runner.horse.trainer.name }}</div>
                </div>
            </div>
            <div class="dark:text-white col-span-1 text-center">
                <span class="dark:text-racing-stars-yellow text-xs rounded-full border h-13 w-13 flex items-center justify-center dark:border-racing-stars-yellow cursor-pointer">{{ runner.forecast_odds_description }}</span>
            </div>

            <span class="col-span-5 grid grid-cols-2 mt-4">
                <span class="bg-racing-stars-yellow block text-sm text-gray-900 col-span-1 p-2 text-center -ml-4">{{ (runner.horse.form) ? runner.horse.form : 'No Form' }}</span>

                <span class="text-sm dark:text-white col-span-1 text-right -mr-4">
                    <button v-if="runnerDetailsId === runner.id" @click.stop.prevent="toggleRunnerDetails(runner)" class="w-full p-2 bg-gray-700 text-sm leading-4 font-medium text-white transition duration-500 ease-in-out col-span-1">
                        <chevron-up-icon class="h-5 w-5 inline-flex mr-1 text-white" aria-hidden="true" />
                    </button>

                    <button v-else @click.stop.prevent="toggleRunnerDetails(runner)" class="w-full p-2 bg-gray-700 text-sm leading-4 font-medium text-white transition duration-500 ease-in-out col-span-1">
                        <chevron-down-icon class="h-5 w-5 inline-flex mr-1 text-white" aria-hidden="true" />
                    </button>
                </span>
            </span>

            <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0" enter-to-class="opacity-100" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <div class="my-4 w-full p-6 dark:bg-gray-700 m-auto col-span-5" v-if="runnerDetailsId === runner.id && runner.horse">
                    <div class="dark:text-white transition duration-500 ease-in-out overflow-scroll">
                        <h4 v-if="runner.jockey" class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Jockey: <span class="font-light">{{ runner.jockey.name }}</span></h4>
                        <h4 v-if="runner.horse.trainer" class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Trainer: <span class="font-light">{{ runner.horse.trainer.name }}</span></h4>
                        <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Form: <span class="font-light">{{ (runner.horse && runner.horse.form !== '') ? runner.horse.form : 'None' }}</span></h4>
                        <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Weight: <span class="font-light">{{ runner.weight }}</span></h4>
                        <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Rating: <span class="font-light">{{ (runner.horse && runner.horse.rating) ? runner.horse.rating : 'None' }}</span></h4>
                        <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Age: <span class="font-light">{{ runner.horse.age }}</span></h4>
                        <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Gate: <span class="font-light">{{ (runner.draw) ? runner.draw : 'N/A' }}</span></h4>
                    </div>
                    <div class="flex dark:text-white transition duration-500 ease-in-out mt-4 dark:bg-gray-500 rounded p-6">
                        <p class="text-gray-900 flex justify-center items-center dark:text-white transition duration-500 ease-in-out">{{ runner.horse.spotlight }}</p>
                    </div>
                </div>
            </transition>
        </div>
        <div v-else>
            <alert type="info" class="mb-4">
                <template #title>
                    Waiting for Race Results!
                </template>
                <template #message>
                    There currently no results for this race. Please check back later.
                </template>
            </alert>
        </div>
    </div>

    <div class="md:hidden grid grid-cols-1 mt-4" v-if="raceHasRunners(reserves, race) && !race.results.length && moment(race.starts_at).subtract(2, 'minutes').isAfter(moment())">
        <h2 class="text-1xl dark:text-white mb-4 text-center">Irish Reserves</h2>
        <template v-for="(runner, key) in reserves" :key="key">
            <div class="relative border-t border-gray-300 bg-white flex items-center hover:border-gray-300 cursor-pointer flex-wrap dark:bg-gray-900 dark:border-gray-600 dark:hover:border-gray-700 transition duration-500 ease-in-out grid grid-cols-5 p-4 pb-0" v-if="moment(race.starts_at).subtract(2, 'minutes').isAfter(moment()) && belongsToRace(race, runner)" @click="selectRunner(runner)">
                <div v-if="runnerExistsInSelected(runner)" class="left-0 top-0 right-0 absolute h-1 bg-racing-stars-yellow">&nbsp;</div>
                <div class="dark:text-white col-span-1 text-center">
                    {{ runner.start_number }}<br />
                    <span>({{ runner.draw }})</span>
                </div>
                <div class="shrink-0 dark:rounded-full dark:bg-white dark:p-2 dark:w-10 dark:h-10 dark:flex dark:items-center dark:justify-center">
                    <img class="w-10" :src="runner.silk_image_path" alt="" />
                </div>
                <div class="dark:text-white col-span-2 truncate">
                    {{ runner.horse.name }}
                    <div class="grid grid-cols-1">
                        <div class="col-span-1 text-xs" v-if="runner.jockey">J: {{ runner.jockey.name }}</div>
                        <div class="col-span-1 text-xs" v-if="runner.horse.trainer">T: {{ runner.horse.trainer.name }}</div>
                    </div>
                </div>

                <span class="col-span-5 grid grid-cols-2 mt-4">
                    <span class="bg-racing-stars-yellow block text-sm text-gray-900 col-span-1 p-2 text-center -ml-4">{{ (runner.horse.form) ? runner.horse.form : 'No Form' }}</span>

                    <span class="text-sm dark:text-white col-span-1 text-right -mr-4">
                        <button v-if="runnerDetailsId === runner.id" @click.stop.prevent="toggleRunnerDetails(runner)" class="w-full p-2 bg-gray-700 text-sm leading-4 font-medium text-white transition duration-500 ease-in-out col-span-1">
                            <chevron-up-icon class="h-5 w-5 inline-flex mr-1 text-white" aria-hidden="true" />
                        </button>

                        <button v-else @click.stop.prevent="toggleRunnerDetails(runner)" class="w-full p-2 bg-gray-700 text-sm leading-4 font-medium text-white transition duration-500 ease-in-out col-span-1">
                            <chevron-down-icon class="h-5 w-5 inline-flex mr-1 text-white" aria-hidden="true" />
                        </button>
                    </span>
                </span>

                <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0" enter-to-class="opacity-100" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100" leave-to-class="opacity-0">
                    <div class="my-4 w-full p-6 dark:bg-gray-700 m-auto col-span-5" v-if="runnerDetailsId === runner.id && runner.horse">
                        <div class="dark:text-white transition duration-500 ease-in-out overflow-scroll">
                            <h4 v-if="runner.jockey" class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Jockey: <span class="font-light">{{ runner.jockey.name }}</span></h4>
                            <h4 v-if="runner.horse.trainer" class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Trainer: <span class="font-light">{{ runner.horse.trainer.name }}</span></h4>
                            <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Form: <span class="font-light">{{ (runner.horse && runner.horse.form !== '') ? runner.horse.form : 'None' }}</span></h4>
                            <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Weight: <span class="font-light">{{ runner.weight }}</span></h4>
                            <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Rating: <span class="font-light">{{ (runner.horse && runner.horse.rating) ? runner.horse.rating : 'None' }}</span></h4>
                            <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Age: <span class="font-light">{{ runner.horse.age }}</span></h4>
                            <h4 class="font-semibold mb-2 dark:text-white transition duration-500 ease-in-out w-full">Gate: <span class="font-light">{{ (runner.draw) ? runner.draw : 'N/A' }}</span></h4>
                        </div>
                        <div class="flex dark:text-white transition duration-500 ease-in-out mt-4 dark:bg-gray-500 rounded p-6">
                            <p class="text-gray-900 flex justify-center items-center dark:text-white transition duration-500 ease-in-out">{{ runner.horse.spotlight }}</p>
                        </div>
                    </div>
                </transition>
            </div>
        </template>
    </div>

    <div class="md:hidden grid grid-cols-1 mt-4" v-if="raceHasRunners(nonRunners, race) && !race.results.length && moment(race.starts_at).subtract(2, 'minutes').isAfter(moment())">
        <h2 class="text-1xl dark:text-white mb-4 text-center">Non-Runners</h2>
        <template v-for="(runner, key) in nonRunners" :key="key">
            <div class="relative border-t border-gray-300 bg-white flex items-center hover:border-gray-300 cursor-pointer flex-wrap dark:bg-gray-900 dark:border-gray-600 dark:hover:border-gray-700 transition duration-500 ease-in-out grid grid-cols-5 p-4" v-if="moment(race.starts_at).subtract(2, 'minutes').isAfter(moment()) && belongsToRace(race, runner)">
                <div v-if="runnerExistsInSelected(runner)" class="left-0 top-0 right-0 absolute h-1 bg-racing-stars-yellow">&nbsp;</div>
                <div class="dark:text-white col-span-1 text-center">
                    {{ runner.start_number }}<br />
                    <span>({{ runner.draw }})</span>
                </div>
                <div class="shrink-0 dark:rounded-full dark:bg-white dark:p-2 dark:w-10 dark:h-10 dark:flex dark:items-center dark:justify-center">
                    <img class="w-10" :src="runner.silk_image_path" alt="" />
                </div>
                <div class="dark:text-white col-span-2 truncate">{{ runner.horse.name }}</div>
                <div class="dark:text-white col-span-1 text-center">
                    <span class="text-sm">{{ runner.horse.form }}</span><br />
                    <span class="dark:text-racing-stars-yellow text-sm">{{ runner.forecast_odds_description }}</span>
                </div>
            </div>
        </template>
    </div>

    <div class="overflow-y-auto">
        <table class="min-w-full divide-y divide-gray-200" v-if="race.results.length">
            <thead class="bg-gray-50 bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900">
                <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                        Position
                    </th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                        Horse
                    </th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                        Jockey
                    </th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                        Points
                    </th>
                    <th scope="col" class="relative px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right transition duration-500 ease-in-out dark:text-white">
                        Odds
                    </th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(result, resultKey) in race.results" :key="resultKey" class="transition duration-500 ease-in-out dark:bg-gray-800" v-show="result.position !== 0">
                    <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                        <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white">{{ getNumberWithOrdinal(result.position) }}</div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                      <div class="flex items-center">
                        <div class="shrink-0 h-10 w-10">
                            <div class="shrink-0 mr-4 rounded-full bg-white p-2 w-10 h-10 flex items-center justify-center">
                                <img class="w-10" :src="result.runner.silk_image_path" alt="" />
                            </div>
                        </div>
                        <div class="ml-4">
                          <div class="text-lg font-bold text-gray-900 transition duration-500 ease-in-out dark:text-white">
                            {{ result.runner.horse.name }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                        <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white">{{ result.runner.jockey ? result.runner.jockey.name : '' }}</div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                        <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white">{{ result.points }}</div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium transition duration-500 ease-in-out dark:text-white">
                        {{ result.odds_description }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { ref, onMounted, computed } from 'vue'
import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/outline'
import { useStore } from 'vuex'
import { sumBy } from 'lodash';
import moment from 'moment';
import Alert from '@/Global/Alert.vue'

export default {
    props: {
        race: Object,
        runners: Object,
        nonRunners: Object,
        reserves: Object,
    },

    setup(props) {
        const furlongToYard = 220;
        const mileToYard = 1760;

        const store = useStore()
        const runnerDetailsId = ref()

        const selectRunner = (runner) => {
            store.commit('updateSelectedRunners', runner)

            let cardTop = document.getElementsByTagName('main')[0]

            cardTop.scroll({ top: 0, behavior: 'smooth' })
        }

        const belongsToRace = (race, runner) => {
            return race.id === runner.race.id
        }

        const raceHasRunners = (runners, race) => {
            return runners.some(runner => runner.race.id === race.id)
        }

        const toggleRunnerDetails = runner => {
            runner.id === runnerDetailsId.value ? runnerDetailsId.value = null : runnerDetailsId.value = runner.id
        }

        const runnerExistsInSelected = runner => {
            let runnerIsSelected = false

            store.getters.selectedRunners.filter(selectedRunner => {
                if (runner.id === selectedRunner.id) {
                    runnerIsSelected = true
                }
            })

            return runnerIsSelected
        }

        const getNumberWithOrdinal = (n) => {
            var s = ['th', 'st', 'nd', 'rd'],
                v = n % 100;

            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        }

        const yardsToMilesAndFurlongs = (yards) => {

            let miles = Math.floor(yards / mileToYard)
            yards = yards % mileToYard

            let furlongs = Math.floor(yards / furlongToYard)
            yards = yards % furlongToYard

            return `${miles > 0 ? miles + 'm' : ''} ${furlongs > 0 ? furlongs + 'f' : ''} ${yards > 0 ? yards + 'y' : ''}`
        }

        return {
            runnerDetailsId,
            toggleRunnerDetails,
            store,
            runnerExistsInSelected,
            getNumberWithOrdinal,
            sumBy,
            yardsToMilesAndFurlongs,
            moment,
            belongsToRace,
            raceHasRunners,
            selectRunner,
        }

    },

    components: {
        CheckIcon,
        ChevronDownIcon,
        ChevronUpIcon,
        Alert,
    }
}

</script>
